const initialState = {
    getdetails1:[],
    getdetails2:[],
    getdetails3:[],
    getdetails4:[],
    image:[],
    view:[],
    
  
  };
  
  const SupViewApproveReducers = (state = initialState, action: any) => {
    switch (action.type) {
            case 'FETCH_GET1_SUCCESS':
            return {... state, getdetails1:action.payload};
            case 'FETCH_GET2_SUCCESS':
            return {... state, getdetails2:action.payload};
            case 'FETCH_GET3_SUCCESS':
            return {... state, getdetails3:action.payload};
            case 'FETCH_GET4_SUCCESS':
            return {... state, getdetails4:action.payload};
            case 'FETCH_IMAGE_SUCCESS':
            return {... state, image:action.payload};
            case 'FETCH_VIEW_SUCCESS':
                return {... state, view:action.payload};
            
           
            
           
          


      default:
        return state;
    }
  };
  
  export default SupViewApproveReducers;
  
  